import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

import { PerformanceGroup } from '@usheru-hff/shared/domain';

import { ShowtimeStreamingMapComponent } from '../showtime-streaming-map/showtime-streaming-map.component';

@Component({
  selector: 'ush-performance-header',
  templateUrl: './performance-header.component.html',
  styleUrls: ['./performance-header.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PerformanceHeaderComponent implements AfterViewInit {
  protected readonly markerIcon = faMapMarkerAlt;
  readonly defaultCinemaPlaceholder = 'https://cdnstatic.usheru.com/img/cinemas/cinemalogo-placeholder.jpg';

  @ViewChild(ShowtimeStreamingMapComponent) mapComponent: ShowtimeStreamingMapComponent;
  @ViewChild('mapTrigger') mapTrigger: ElementRef<HTMLElement>;

  @Input() performance: PerformanceGroup;

  ngAfterViewInit() {
    if (this.mapComponent) {
      this.mapComponent.focusElementOnClose = this.mapTrigger;
    }
  }

  openMap() {
    this.mapComponent.openMap();
  }

  openMapKey(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      this.openMap();
    }
  }

  handleCinemaErrorImg(elem) {
    elem.target.src = this.defaultCinemaPlaceholder;
  }
}
